module.exports = __webpack_public_path__ + "img/cd.665279f3.svg";